<mat-toolbar>
    <div class="toolbar-left">
        <div class="toolbar-item icon">
            <div class="icon-container" (click)="displayPreviousStage()">
                <mat-icon aria-hidden="false" fontIcon="chevron_left"></mat-icon>
            </div>
        </div>
    </div>
    <div class="toolbar-center">
        <div class="toolbar-item stage-number">
            <p>1</p>
        </div>
        <div class="toolbar-item stage-name">
            <p>Experiment Details</p>
        </div>
        <div class="toolbar-item divider"></div>
        <div class="toolbar-item stage-number {{stageLevel < 2 ? 'grayscaled' : ''}}">
            <p>2</p>
        </div>
        <div class="toolbar-item stage-name {{stageLevel < 2 ? 'grayscaled' : ''}}">
            <p>Import Dataset</p>
        </div>
        <div class="toolbar-item divider"></div>
        <div class="toolbar-item stage-number {{stageLevel < 3 ? 'grayscaled' : ''}}">
            <p>3</p>
        </div>
        <div class="toolbar-item stage-name {{stageLevel < 3 ? 'grayscaled' : ''}}">
            <p>View Dataset Details</p>
        </div>
        <div class="toolbar-item divider"></div>
        <div class="toolbar-item stage-number {{stageLevel < 4 ? 'grayscaled' : ''}}">
            <p>4</p>
        </div>
        <div class="toolbar-item stage-name {{stageLevel < 4 ? 'grayscaled' : ''}}">
            <p>Create Parameter Overrides</p>
        </div>
    </div>
    <div class="toolbar-right">
        <div class="toolbar-item button" (click)="displayNextStage()">
            <p>Next</p>
        </div>
    </div>
</mat-toolbar>
<div class="content-body-background"></div>
<div class="content-body">
    <ng-container *ngComponentOutlet="experimentCreateStage.component" />
</div>